import React from 'react'
import { The, notify } from '../../../helpers/generalHelpers'
import settings from '../../../settings'
import BarSpinner from 'stories/components/Loading/Spinner/bar-spinner'
import { services } from 'api/api'

const { redirectUri } = settings
class RedirectToICAS extends React.Component {
  state = {
    url: undefined,
  }

  async componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search)
    const [errors, response] = await The(services.auth.getICASRedirectUrl())
  
    if (errors) {
      notify(errors, 'error')
      return
    }
  
    this.setState(
      {
        url: `${response.oauth2.redirection_url}&redirect_uri=${redirectUri}${queryParams.size > 0 ? '&' + queryParams : ''}`,
      },
      () => {
        window.location.replace(this.state.url)
      }
    )
  }

  render() {
    return <BarSpinner fullPage overlay />
  }
}

export default RedirectToICAS
